import React from 'react'
import './Icon.css'

function Icon({ IconName, color }) {
  return (
     <IconName className='fileManager__icon' color="primary"  />
  )
}

export default Icon